import { createStore } from 'vuex'
import main from './main'
import topMenu from './top-menu'
import auth from './auth'
import breadcrumbs from './breadcrumbs'
import notification from './notification'
import memo from './memo'
import pv from './pv'
import ca from './ca'
import cl from './cl'
import pr from './pr'
import po from './po'
import gr from './gr'
import of from './of'
import rf from './rf'
import global from './global'
import budget from './budget'
import specialPath from './special-path'

const store = createStore({
  modules: {
    main,
    auth,
    topMenu,
    breadcrumbs,
    notification,
    memo,
    pv,
    ca,
    cl,
    pr,
    po,
    gr,
    of,
    rf,
    global,
    budget,
    specialPath
  }
})
export function useStore() {
  return store
}

export default store
